<template>
  <el-input
    ref="input"
    :value="displayValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    :max="max"
    :min="min"
    @blur="handleBlur"
    @focus="handleFocus"
    @input="handleInput"
    @change="handleInputChange"
  >
  </el-input>
</template>
<script>
import NP from 'number-precision';

export default {
  name: 'InputNumber',
  props: {
    max: {
      type: Number,
      default: Infinity,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    value: {},
    disabled: Boolean,
    size: String,
    placeholder: String,
    precision: {
      type: Number,
      validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      },
      default: 0,
    },
  },
  data() {
    return {
      currentValue: '',
      userInput: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        let newVal = (value === '' || value === undefined) ? value : Number(value);
        if (newVal !== undefined && newVal !== '') {
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(newVal)) {
            return;
          }
          newVal = this.toPrecision(newVal, this.precision);
          if (newVal >= this.max) newVal = this.max;
          if (newVal <= this.min) newVal = this.min;
        }
        this.currentValue = newVal;
        this.userInput = null;
        this.$emit('input', newVal);
      },
    },
  },
  computed: {
    displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }
      let { currentValue } = this;
      if (typeof currentValue === 'number') {
        currentValue = NP.round(currentValue, this.precision);
      }
      return currentValue;
    },
  },
  methods: {
    toPrecision(num, precision) {
      return NP.round(num, precision);
    },
    setCurrentValue(newVal) {
      const oldVal = this.currentValue;
      if (typeof newVal === 'number') {
        newVal = this.toPrecision(newVal, this.precision);
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
      }
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput(value) {
      this.userInput = value;
    },
    handleInputChange(value) {
      const newVal = value === '' ? value : Number(value);
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      }
      this.userInput = null;
    },
    handleBlur(event) {
      this.$emit('blur', event);
    },
    handleFocus(event) {
      this.$emit('focus', event);
    },
  },
};
</script>
